module.exports = __webpack_public_path__ + "assets/images/a957f4ddb5f100709d339551a8d95fc8.png";